import { Filters } from '../../../utils/enums';

export const supportedFilters: Filters[] = [];
